export const deleteDialogCommonViewTexts = {
  confirmMessagePrefix: 'を削除してもよろしいですか？',
  cancel: '削除せずに戻る',
  ok: '削除する',
  messageGenerator1: (title: string) => (name: string) => [
    `${title}「${name}」を削除します。`,
    `削除するとこの${title}のすべてのデータにアクセスすることができなくなります。`,
    'この操作は取り消すことができません。'
  ]
};
